import styled from 'styled-components'

export const StyledSideBar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`

export const SideBarButton = styled.button<{ active?: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  font-weight: ${props => props.theme.fontWeight.medium};
  padding: ${props => props.theme.spacing.medium};
  border-radius: ${props => props.theme.radius.normal};
  background-color: ${props => (props.active ? props.theme.colors.secondary[50] : 'transparent')};
  text-align: left;
  transition: background-color 0.16s ease-in-out;

  &:hover {
    background-color: ${props =>
      props.active ? props.theme.colors.secondary[50] : props.theme.colors.secondary[25]};
  }

  svg {
    width: 1.25rem;
    height: 1.25rem;
    fill: ${props => props.theme.colors.secondary[500]};
    margin-right: ${props => props.theme.spacing.default};
  }

  span {
    width: calc(100% - 1.25rem - ${props => props.theme.spacing.default});
    line-height: 1.5;
  }

  &:not(:last-of-type) {
    margin-bottom: ${props => props.theme.spacing.default};
  }
`
